import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #2B7A9B 0%, #8B3B8B 100%);
  position: relative;
  overflow: hidden;
`;

const Dashboard: React.FC = () => {
  return <PageContainer />;
};

export default Dashboard; 